import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/logo-icon.png'


const _hoisted_1 = { class: "row justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-10 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Basic Toasts"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview-tab",
              tabindex: "0"
            }, [
              _createElementVNode("div", {
                class: "toast show bg-white",
                role: "alert",
                "aria-live": "assertive",
                "aria-atomic": "true"
              }, [
                _createElementVNode("div", { class: "toast-header border-color" }, [
                  _createElementVNode("img", {
                    src: _imports_0,
                    class: "rounded me-2",
                    alt: "..."
                  }),
                  _createElementVNode("strong", { class: "me-auto fs-18 fw-bold text-dark" }, "Trezo"),
                  _createElementVNode("small", null, "11 mins ago"),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-close",
                    "data-bs-dismiss": "toast",
                    "aria-label": "Close"
                  })
                ]),
                _createElementVNode("div", { class: "toast-body" }, " Hello, world! This is a toast message. ")
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode"
                }, "\n<div class=\"toast show bg-white\" role=\"alert\" aria-live=\"assertive\" aria-atomic=\"true\">\n<div class=\"toast-header border-color\">\n<img src=\"@/assets/images/logo-icon.png\" class=\"rounded me-2\" alt=\"...\">\n<strong class=\"me-auto fs-18 fw-bold text-dark\">Trezo</strong>\n<small>11 mins ago</small>\n<button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"toast\" aria-label=\"Close\"></button>\n</div>\n<div class=\"toast-body\">\nHello, world! This is a toast message.\n</div>\n</div>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-10 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Live Example Toasts"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab2",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview2-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview2-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview2-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code2-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code2-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code2-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent2"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview2-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview2-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary text-white fw-semibold py-2 px-3",
                id: "liveToastBtn"
              }, " Show live toast "),
              _createElementVNode("div", { class: "toast-container position-fixed bottom-0 end-0 p-3" }, [
                _createElementVNode("div", {
                  id: "liveToast",
                  class: "toast",
                  role: "alert",
                  "aria-live": "assertive",
                  "aria-atomic": "true"
                }, [
                  _createElementVNode("div", { class: "toast-header" }, [
                    _createElementVNode("img", {
                      src: _imports_0,
                      class: "rounded me-2",
                      alt: "..."
                    }),
                    _createElementVNode("strong", { class: "me-auto" }, "Bootstrap"),
                    _createElementVNode("small", null, "11 mins ago"),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn-close",
                      "data-bs-dismiss": "toast",
                      "aria-label": "Close"
                    })
                  ]),
                  _createElementVNode("div", { class: "toast-body" }, " Hello, world! This is a toast message. ")
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code2-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code2-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode2"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode2"
                }, "\n<button type=\"button\" class=\"btn btn-primary text-white fw-semibold py-2 px-3\" id=\"liveToastBtn\">Show live toast</button>\n\n<div class=\"toast-container position-fixed bottom-0 end-0 p-3\">\n<div id=\"liveToast\" class=\"toast\" role=\"alert\" aria-live=\"assertive\" aria-atomic=\"true\">\n<div class=\"toast-header\">\n<img src=\"@/assets/images/logo-icon.png\" class=\"rounded me-2\" alt=\"...\">\n<strong class=\"me-auto\">Bootstrap</strong>\n<small>11 mins ago</small>\n<button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"toast\" aria-label=\"Close\"></button>\n</div>\n<div class=\"toast-body\">\nHello, world! This is a toast message.\n</div>\n</div>\n</div>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1)
  ])))
}